import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router-dom";
import Banner from "../Banner/Banner";
import axios from "axios";
import Swal from "sweetalert2";
const Login = () => {
   const [showPassword, setShowPassword] = useState(false);
     const [loading, setLoading] = useState(false); 
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: true,
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
   setLoading(true);
  try {
    const res = await axios.post("https://vantara.datacubeglobal.com/api/login", {
      mobile: formData.mobile,
      password: formData.password,
    });

    if (res.data.status === "success") {
    
      sessionStorage.setItem("userData", JSON.stringify(res.data));

 


      Swal.fire({
        icon: "success",
        title: "Login successful!",
        confirmButtonColor: "#1c3f1d",
        confirmButtonText: "OK",
      });


      navigate("/shop");
    } else {
    
      Swal.fire({
        icon: "error",
        title: "Login failed!",
        text: res.data.message,
        confirmButtonColor: "#1c3f1d",
      });
    }
  } catch (err) {
  
    Swal.fire({
      icon: "error",
      title: "Login failed!",
      text: err.response?.data?.message || "Something went wrong",
      confirmButtonColor: "#1c3f1d",
    });
    console.error(err);
   } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Banner title="Login" />
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="row g-5 align-items-start">
            <div className="col-md-6 border-end pe-lg-5">
              <h2 className="mb-4 ">Login</h2>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    // type="text"
                    className="form-control form-control-lg"
                    placeholder=" Mobile No*"
                    name="mobile"
                   value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3 position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control form-control-lg pe-5"
                    placeholder="Password*"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                  <span
                    className="position-absolute end-0 top-50 translate-middle-y me-3"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={`bi ${
                        showPassword ? "bi-eye-slash" : "bi-eye"
                      }`}
                    ></i>
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  {/* <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="rememberMe"
                      name="rememberMe"
                      checked={formData.rememberMe}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="rememberMe">
                      Remember me
                    </label>
                  </div> */}
                  {/* <a href="#forgot" className="text-decoration-none small">
                    Forgot Your Password?
                  </a> */}
                </div>
                <div className="flex d-flex justify-content-center">
                    <button type="submit" className="btn  rounded-pill px-5 py-2"  style={{background:'#1C3F1D',color:'white'}}>
                {loading ? "Logging in..." : "Login"}
                </button>
                </div>
             
              </form>
            </div>
            <div className="col-md-6 ps-lg-5">
              <h3 className="mb-3 ">New Customer</h3>
              <p className="mb-4 text-muted">
                Be part of our growing family of new customers! Join us today and unlock a world of exclusive benefits, offers, and
                personalized experiences.
              </p>
                <div className="flex d-flex justify-content-center">
                   <button type="submit" className="rounded-pill px-5 py-2"   style={{background:'#1C3F1D',color:'white'}}  onClick={() => navigate("/register")}>
                Register
              </button>
                </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr/>
    </>
  );
};

export default Login;

// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import Banner from "../Banner/Banner";

// const Login = () => {
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//     rememberMe: true,
//   });
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post("https://vantara.datacubeglobal.com/api/login", {
//         email: formData.email,
//         password: formData.password,
//       });
//       if (res.data.status === "success") {
//         // Store the whole response in session storage
//         sessionStorage.setItem("userData", JSON.stringify(res.data));
//         Swal.fire("Login successful!", "", "success");
//         // Redirect or reload as needed
//         // navigate("/"); 
//       } else {
//         Swal.fire(res.data.message || "Login failed!", "", "error");
//       }
//     } catch (err) {
//       Swal.fire("Login failed!", "", "error");
//       console.error(err);
//     }
//   };

//   return (
//     <>
//       <Banner title="Login" />
//       <div className="container py-5" style={{ fontFamily: "'Kumbh Sans', sans-serif" }}>
//         <div className="row justify-content-center">
//           <div className="col-lg-8">
//             <div className="row g-0 shadow rounded-4 overflow-hidden">
//               {/* Left: Login Form */}
//                <div className="d-flex justify-content-center">
//   <h2 className="mb-4 fw-bold ">Login</h2>
// </div>
//               <div className="col-md-6 bg-white p-4">
             
          
//                 <form onSubmit={handleSubmit} autoComplete="off">
//                   <div className="mb-3">
//                     <label htmlFor="loginEmail" className="form-label fw-semibold">
//                       Email address
//                     </label>
//                     <input
//                       type="email"
//                       className="form-control form-control-lg"
//                       id="loginEmail"
//                       placeholder="Enter your email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       required
//                       autoFocus
//                     />
//                   </div>
//                   <div className="mb-3 position-relative">
//                     <label htmlFor="loginPassword" className="form-label fw-semibold">
//                       Password
//                     </label>
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       className="form-control form-control-lg pe-5"
//                       id="loginPassword"
//                       placeholder="Enter your password"
//                       name="password"
//                       value={formData.password}
//                       onChange={handleChange}
//                       required
//                     />
//                     <span
//                       className="position-absolute end-0 top-50 translate-middle-y me-3"
//                       onClick={() => setShowPassword(!showPassword)}
//                       style={{ cursor: "pointer" }}
//                       aria-label={showPassword ? "Hide password" : "Show password"}
//                       tabIndex={0}
//                     >
//                       <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
//                     </span>
//                   </div>
//                   <div className="d-flex justify-content-between align-items-center mb-4">
//                     <div className="form-check">
//                       <input
//                         type="checkbox"
//                         className="form-check-input"
//                         id="rememberMe"
//                         name="rememberMe"
//                         checked={formData.rememberMe}
//                         onChange={handleChange}
//                       />
//                       <label className="form-check-label" htmlFor="rememberMe">
//                         Remember me
//                       </label>
//                     </div>
//                     <a href="#forgot" className="text-decoration-none small">
//                       Forgot Password?
//                     </a>
//                   </div>
//                   <div className="d-grid">
//                     <button type="submit" className="btn btn-dark rounded-pill px-5 py-2 fw-bold">
//                       Login
//                     </button>
//                   </div>
//                 </form>
//               </div>
//               {/* Right: New Customer */}
//               <div className="col-md-6 bg-light d-flex flex-column justify-content-center align-items-center p-4">
//                 <h3 className="mb-3 fw-bold text-center">New Customer</h3>
//                 <p className="mb-4 text-muted text-center">
//                   Join us today and unlock exclusive benefits, offers, and personalized experiences.
//                 </p>
//                 <button
//                   type="button"
//                   className="btn btn-outline-dark rounded-pill px-5 py-2 fw-bold"
//                   onClick={() => navigate("/register")}
//                 >
//                   Register
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <hr />
//     </>
//   );
// };

// export default Login;